import { useMediaQuery } from 'src/lib/use-media-query'
import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['OTTIENI'],
    small: ['RUOTA', 'OTTIENI'],
}

export const TextHeaderIt = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="GIRA LA RUOTA E OTTIENI GIRI GRATUITI"
            highlights={[{ word: 'GIRI' }, { word: 'GRATUITI' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
